import axiosInstance from '../../axios-config';

export const getRelationshipsLookup = () => axiosInstance.get('/api/lookups/relationships');

export const getCountriesLookup = () => axiosInstance.get('/api/lookups/countries');

export const getPreferredCommunicationsLookup = () => axiosInstance.get('/api/lookups/preferredCommunications');

export const getStatesLookup = () => axiosInstance.get('/api/lookups/states');

export const checkSsoEnabled = () => axiosInstance.get('/api/lookups/ssoenabled');
